const parseFabricMaterial = fabricMaterial => {
  let materials;
  try {
    materials = JSON.parse(fabricMaterial);
  } catch {
    materials = fabricMaterial;
  }
  return Array.isArray(materials) ? materials : [materials];
};

export default parseFabricMaterial;
